<template>
  <div style="width: 100%; height: 100%;"></div>
</template>

<script>
export default {
    props:  {
        address: {
            required: true,
            type: String
        },
        zoom: {
            required: false,
            type: Number,
            default: 15
        }
    },
    mounted: function() {
        var geocoder = new google.maps.Geocoder();
        var params = {
            'address': this.address,
            'region': 'jp'
        };
        var el = this.$el;
        var zoom = this.zoom;
        geocoder.geocode(params, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                return;
            }
            google.maps.event.addDomListener(window, 'load', function() {
                var position = new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng());
                var map = new google.maps.Map(el, {
                    zoom: zoom,
                    center: position,
                    disableDefaultUI: false,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                });
                new google.maps.Marker({
                    position: position,
                    map: map
                });
            });
        });
    }
}
</script>
